import React from 'react';
import { connect } from 'react-redux';
import { Table, Container, Row, Col, Button } from 'reactstrap';
import i18n from "../../../i18next";
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';

import { loadPromotionSummarySearch , loadPromotionNames} from '../../../actions/restaurants/customerInsight/CustomerInsightAction';
import { loadRestaurantInsightPromotionSummarySearch } from '../../../actions/restaurants/restaurantInsight/RestaurantInsightAction';
import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from "../../../utils/Constants";
import AutoCompleteSearch from '../../central/autosearch/AutoCompleteSearch';


class PromotionSummary extends React.Component {

    state = {
        page: 0,
        promotionId: '',
        promotionName: ''
    }

    componentDidMount() {
        const { restaurantId, customerId } = this.props;
        if (this.props.isRestaurantInsight) {
            this.props.loadRestaurantInsightPromotionSummarySearch(restaurantId, this.state.page, this.state.promotionId, this.state.promotionName)
        } else {
            this.props.loadPromotionSummarySearch(restaurantId, customerId, this.state.page, this.state.promotionId, this.state.promotionName);
        }
    }

    handlePageChange = pageNumber => {
        const { restaurantId, customerId } = this.props;

        if (this.props.isRestaurantInsight) {
            this.setState({
                page: (pageNumber - 1)
            }, () => this.props.loadRestaurantInsightPromotionSummarySearch(restaurantId, this.state.page, this.state.promotionId, this.state.promotionName));
        } else {
            this.setState({
                page: (pageNumber - 1)
            }, () => this.props.loadPromotionSummarySearch(restaurantId, customerId, this.state.page, this.state.promotionId, this.state.promotionName));
        } 
    }

    renderProductSummaryTable = () => {
        return (
            <Table bordered hover style={{ marginTop: '25px' }}>
                <thead>
                    {this.renderTableHeaders()}
                </thead>
                <tbody>
                    {this.renderTableContent()}
                </tbody>
            </Table>
        );
    }

    renderTableHeaders = () => {

        const { tableHeaders, textCenter, textRight } = styles;

        return (
            <tr>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.promotion')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.timesRedeemed')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.totalSpent')}</th>
            </tr>
        );
    }

    renderTableContent = () => {
        if(this.props.isRestaurantInsight && this.props.restaurantInsightPromotionSummary) {
            return  this.props.restaurantInsightPromotionSummary.content.map(item => {
                return this.renderSingleItem(item);
            })
        } else {
            return this.props.customerInsightPromotionSummary.content.map(item => {
                return this.renderSingleItem(item);
            })
        }
    }

    renderSingleItem = item => {

        const { tableDetail, firstRow, textCenter, textRight } = styles;
        const currency = this.props.restaurant.currency;

        return (
            <tr>
                <td style={{ ...tableDetail, ...firstRow }}>{item.promotionName}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.count}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.discountAmount, currency)}</td>
            </tr>
        );
    }

    renderAdditionalSearchOptions = () => {

        return (
            <Container fluid>
                <Row>
                    {this.renderPromotionNameAutoselect()}
                    {this.renderSubmitButton()}
                </Row>
            </Container>
        );
    }

    changeState = (e, promotion) => {
        if (promotion) {
            this.setState({ promotionId: promotion.id, promotionName: promotion.name })
        } else {
            this.setState({ promotionId: '', promotionName: e.target.value })
        }
    }

    renderPromotionNameAutoselect = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <AutoCompleteSearch
                    inputId='name'
                    inputName='name'
                    placeholder={i18n.t('screens:restaurantInsightScreen.promotionName')}
                    inputValue={this.state.promotionName}
                    inputStyle={{}}
                    changeState={this.changeState}
                    searchValues={this.props.customerInsightPromotionNames} />
            </ Col>
        );
    }

    loadPromotions = () => {
        const { restaurantId, customerId } = this.props;

        if(this.props.isRestaurantInsight) {
            this.props.loadRestaurantInsightPromotionSummarySearch(restaurantId, this.state.page, this.state.promotionId, this.state.promotionName);
        } else {
            this.props.loadPromotionSummarySearch(this.props.restaurantId, this.props.customerId, this.state.page, this.state.promotionId, this.state.promotionName)
        }
    }

    renderSubmitButton = () => {
        return (
            <Col xs={9} sm={9} style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 0 }}>
                <Button
                    color='primary'
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: 6 }}
                    onClick={() => this.loadPromotions()}
                >
                    <MaterialIcon icon="search" color="#fff" size={19} />
                    <div style={{ marginLeft: 5 }}>{i18n.t('screens:customerInsightScreen.search')}</div>
                </Button>
            </Col>
        );

    }

    renderPagination() {
        const { flexEnd } = styles;
        const promotionSummaryNumber = (this.props.isRestaurantInsight && this.props.restaurantInsightPromotionSummary) ? this.props.restaurantInsightPromotionSummary.number : this.props.customerInsightPromotionSummary.number;
        const promotionSummaryTotalElements = (this.props.isRestaurantInsight && this.props.restaurantInsightPromotionSummary) ? this.props.restaurantInsightPromotionSummary.totalElements : this.props.customerInsightPromotionSummary.totalElements;

        return (
            <Container>
                <Row>
                    <Col style={flexEnd}>
                        <Pagination
                            activePage={promotionSummaryNumber + 1}
                            itemsCountPerPage={DEFAULT_PAGE_SIZE}
                            totalItemsCount={promotionSummaryTotalElements}
                            pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                            itemClass='page-item'
                            linkClass='page-link'
                            onChange={this.handlePageChange}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.renderAdditionalSearchOptions()}
                {this.renderProductSummaryTable()}
                {this.renderPagination()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerInsightPromotionSummary: state.customerInsightPromotionSummary,
        customerInsightPromotionNames: state.customerInsightPromotionNames,
        restaurantInsightPromotionSummary: state.restaurantInsight.promotionSummary,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { 
    loadPromotionSummarySearch,
    loadPromotionNames,
    loadRestaurantInsightPromotionSummarySearch })(PromotionSummary);

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px',
        fontSize: '14px',   //previously it was 14px not bolded
        fontWeight: 'bold',
    },
    firstRow: {
        //whiteSpace: 'nowrap'
        paddingRight: '0'
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    textRight: {
        textAlign: 'right',
        paddingLeft: '0'
    },
    flexEnd: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/PromotionSummary.js